import avatar from "@/assets/img/logo12.png";

import SendIcon from "@/components/shared/icons/SendIcon";
import { RootState } from "@/reducers";
import { IMessage } from "@/shared/model/message.model";
import { useRouter } from "@/shared/utils/hooks/useRouter";
import { AppDispatch } from "@/store";
import {
  CAvatar,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CSpinner,
} from "@coreui/react-pro";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEntities } from "../Chat/Message/message.api";
import {
  fetching,
  initialMessageFilter,
  messageSelectors,
  resetFilterState,
  setFilterState,
} from "../Chat/Message/message.reducer";
import { ICreateChatResponse } from "@/shared/model/chat.model";
import axios from "../../../shared/config/axios-interceptor";
import { handleUploadImage } from "@/shared/utils/ultils";
import ImageSendIcon from "@/components/shared/icons/web/ImageSendIcon";
import { SOCKET_URL } from "@/shared/config/constants";
import { io } from "socket.io-client";
import { PhotoProvider, PhotoView } from "react-photo-view";

const MessageAgent = () => {
  const { params } = useRouter();
  const { userId, agentId } = params;

  const socket = io(SOCKET_URL, {
    //   Thêm các options cần thiết
    extraHeaders: {
      token: userId?.toString() || "",
    },
  });

  if (!userId) return <></>;

  return (
    <Chat agentId={Number(agentId)} userId={Number(userId)} socket={socket} />
  );
};

interface IProps {
  userId: number;
  socket: any;
  agentId: number;
}
const Chat = (props: IProps) => {
  const { userId, socket, agentId } = props;

  const dispatch = useDispatch<AppDispatch>();
  const { bodyWidth } = useSelector((state: RootState) => state.container);
  const { initialState } = useSelector(
    (state: RootState) => state.messageReducer
  );
  const { messageInfoShow, totalPages, filterState, loading } = initialState;
  const listMessage = useSelector(messageSelectors.selectAll);

  const [load, setLoad] = useState(false);

  const fileInput = useRef<any>(null);

  const listMessageRef = useRef<HTMLDivElement>(null);
  const [messages, setMessages] = useState<IMessage[]>([]);
  const [messageInput, setMessageInput] = useState("");

  const [roomId, setRoomId] = useState(0);

  const chatBoxWidth = messageInfoShow
    ? `calc(100% - ${bodyWidth * 0.25}px)`
    : "100%";

  const isSender = (senderId: number) => senderId == Number(userId);

  const isSenderHasPreviousMsg = (msg: IMessage, index: number) =>
    index + 1 < messages.length && messages[index + 1].senderId == msg.senderId;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key == "Enter" && messageInput.trim()) {
      sendMessage();
    }
  };

  const getRoom = async () => {
    try {
      const response = await axios.get(
        "/room/get-room-user?userId=" + userId + "&agentId=" + agentId
      );
      if (!response?.data?.id) {
        socket.emit("new_room", { users: [agentId, userId], name: "" });
      } else {
        setRoomId(response?.data?.id);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    socket.on(`user_${userId}_new_room`, (res: ICreateChatResponse) => {
      if (res) {
        const messageData = {
          id: res?.id,
          content: "Xin chào bạn đến với AMAZON. Bạn cần hỗ trợ về vấn đề gì?",
          agentId: Number(agentId),
          newMessage: true,
          users: [Number(userId), Number(agentId)],
        };
        setRoomId(res?.id);
        socket.emit("send_message", messageData);
      }
    });

    return () => {
      socket.off(`user_${userId}_new_room`);
    };
  }, [userId]);

  useEffect(() => {
    getRoom();
  }, [userId]);

  const scrollToBottom = () => {
    const timeout = setTimeout(() => {
      // Scroll to the bottom of the messages div
      if (listMessageRef.current) {
        listMessageRef.current.scrollTop = listMessageRef.current.scrollHeight;
      }
    }, 700);

    return () => clearTimeout(timeout);
  };

  const sendMessage = () => {
    if (!messageInput.trim()) {
      return;
    }

    const messageData = {
      id: roomId,
      content: messageInput,
      agentId: Number(agentId),
      users: [Number(userId), Number(agentId)],
      currentUserId: Number(userId),
    };
    setLoad(true);
    socket.emit("send_message", messageData);
  };

  const handleScroll = () => {
    const div = listMessageRef.current;

    if (div?.scrollTop == 0) {
      console.log("Đã đến đầu list message");
      if (totalPages > 1)
        dispatch(
          setFilterState({ ...filterState, limit: filterState.limit + 50, customer: true })
        );
    }
  };

  useEffect(() => {
    const div = listMessageRef.current;

    if (Number(roomId)) {
      dispatch(
        setFilterState({ ...initialMessageFilter, roomId: Number(roomId), customer: true })
      );
    }
    scrollToBottom();

    return () => {
      dispatch(resetFilterState());
      div?.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId]);

  useEffect(() => {
    if (filterState.roomId) {
      dispatch(fetching());
      dispatch(getEntities({ ...filterState, userId: Number(userId), customer: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterState)]);

  useEffect(() => {
    setMessages([...listMessage].reverse());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(listMessage)]);

  useEffect(() => {
    socket.on(`user_${userId}_new_message`, (newMsg: IMessage) => {
      if (newMsg?.senderId == userId) {
        setLoad(false);
      }
      if (Number(roomId) === newMsg.roomId) {
        setMessageInput("");
        setMessages([...messages, newMsg]);
        scrollToBottom();
      }
    });

    socket.on(`user_${userId}_remove_message`, (data: any) => {
      const newMessage = messages.filter((msg) => msg._id !== data);
      setMessages(newMessage);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, totalPages, roomId]);

  useEffect(() => {
    const div = listMessageRef.current;
    div?.addEventListener("scroll", handleScroll);

    return () => {
      div?.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterState), totalPages]);

  const uploadFile = async (file: File) => {
    // const file =  {};
    try {
      return await handleUploadImage(file);
    } catch (e) {
      console.error("Error uploading file", e);
    }
  };

  const onChangeFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];
      const messageData = {
        id: roomId,
        content: "",
        agentId: Number(agentId),
        users: [Number(userId), Number(agentId)],
        image: await uploadFile(file),
        currentUserId: Number(userId),
      };
      socket.emit("send_message", messageData);
      if (fileInput.current) {
        fileInput.current.value = "";
      }
    }
  };

  const sendRead = async () => {
    try {
      await axios.post("/message/" + roomId + "/read");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (roomId) {
      sendRead();
    }
  }, [roomId]);

  return (
    <>
      <div className="box-chat-customer box-chat-customer-wap">
        <div className="message-box" style={{ width: chatBoxWidth }}>
          <div className="chat-box-container" ref={listMessageRef}>
            {loading ? (
              <div className="text-center">
                <CSpinner className="text-primary" />
              </div>
            ) : null}

            <PhotoProvider>
              {messages.map((msg, index) =>
                isSender(msg.senderId) ? (
                  <div
                    key={`chat-${index}`}
                    className="d-flex justify-content-end"
                    style={{
                      marginBottom:
                        index + 1 == messages.length
                          ? 0
                          : isSenderHasPreviousMsg(msg, index)
                          ? "4px"
                          : "16px",
                    }}
                  >
                    <div className="chat-box primary" style={{ maxWidth: 300 }}>
                      {msg?.image ? (
                        <PhotoView src={msg?.image}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={msg?.image}
                          />
                        </PhotoView>
                      ) : (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: msg.content.replace(/\n/g, "<br/>"),
                          }}
                        ></div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    key={`chat-${index}`}
                    className="d-flex align-items-end"
                    style={{
                      marginBottom:
                        index + 1 == messages.length
                          ? 0
                          : isSenderHasPreviousMsg(msg, index)
                          ? "4px"
                          : "16px",
                    }}
                  >
                    <div className="avatar-32 me-2">
                      {isSenderHasPreviousMsg(msg, index) ? null : (
                        <CAvatar
                          style={{ background: "#113b49", padding: 4 }}
                          src={msg.sender?.avatar || avatar}
                          className="avatar-32"
                        />
                      )}
                    </div>
                    <div>
                      <div className="chat-box" style={{ maxWidth: 300 }}>
                        {msg?.image ? (
                          <PhotoView src={msg?.image}>
                            <img
                              width={"100%"}
                              height={"100%"}
                              src={msg?.image}
                            />
                          </PhotoView>
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: msg.content.replace(/\n/g, "<br/>"),
                            }}
                          ></div>
                        )}
                      </div>
                    </div>
                  </div>
                )
              )}
            </PhotoProvider>
          </div>
          <div className="chat-input-container d-flex align-items-center gap-2">
            <label htmlFor="file">
              <ImageSendIcon />
            </label>
            <input
              type="file"
              id="file"
              className="d-none"
              onChange={onChangeFile}
              ref={fileInput}
            />
            <CInputGroup className="input-start-group">
              <CFormInput
                disabled={load}
                placeholder="Viết tin nhắn..."
                name="content"
                autoComplete="off"
                value={messageInput}
                onChange={(e) => setMessageInput(e.target.value)}
                className="fs-6"
                onKeyDown={handleKeyDown}
              />
              {
                <CInputGroupText
                  onClick={sendMessage}
                  className="cursor-pointer"
                >
                  <SendIcon />
                </CInputGroupText>
              }
            </CInputGroup>
          </div>
        </div>
      </div>
    </>
  );
};
export default MessageAgent;
